<div class="hero-header">
    <div class="hero-header__inner">
        <div class="hero-header__hd">
            <!-- <shared-header [brandAccent]="true" type="5" marginTop="xs" marginBottom="none" class="hero-header__subh"
                *ngIf="preTitle">
                {{preTitle}}
            </shared-header> -->

            <shared-header class="hero-header__subh" *ngIf="preTitle" [postContent]="preHeaderPostContent"
                [preContent]="preHeaderPreContent" [ellipsis]="preHeaderEllipsis" [center]="preHeaderCenter"
                [inverted]="preHeaderInverted" [counter]="preHeaderCounter" [loading]="loading" [type]="preHeaderType"
                [left]="preHeaderLeft" [right]="preHeaderRight" [marginTop]="preHeaderMarginTop"
                [marginBottom]="preHeaderMarginBottom" [paddingTop]="preHeaderPaddingTop"
                [paddingBottom]="preHeaderPaddingBottom" [brandAccent]="preHeaderBrandAccent" class="info-box__hd">
                {{preTitle}}
            </shared-header>

            <shared-header class="hero-header__h" [postContent]="postContent" [preContent]="preContent"
                [ellipsis]="ellipsis" [center]="center" [counter]="counter" [inverted]="inverted" [loading]="loading"
                [type]="type" [left]="left" [right]="right" [marginTop]="marginTop" [marginBottom]="marginBottom"
                [paddingTop]="paddingTop" [paddingBottom]="paddingBottom" [brandAccent]="brandAccent"
                class="info-box__hd">
                <ng-content></ng-content>
            </shared-header>
        </div>

        <div class="hero-header__bd" *ngIf="postTitle">
            <ng-container *ngTemplateOutlet="postTitle"></ng-container>
        </div>
    </div>
</div>
